import { Button, Tooltip } from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import ToggleOffIcon from "@material-ui/icons/ToggleOff";
import ToggleOnIcon from "@material-ui/icons/ToggleOn";
import React, { useEffect, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import {
	Card,
	CardBody,
	CardHeader,
	CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import { SERVER_URL } from "../../../../api";
import {
	changeStatusActivity,
	deleteActivity,
	getActivities,
} from "../../../../api/activity";
import { getNonEmpty } from "../../../../utils/helpers";
import { alertError, alertSuccess } from "../../../../utils/logger";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import PreviewDialog from "../../../components/dialogs/PreviewDialog";
import Table, {
	buttonsStyle,
	dateFormatter,
} from "../../../components/tables/table";

function getData(activities) {
	let data = [];
	for (let i = 0; i < activities.length; ++i) {
		const elem = {};
		const actA = activities[i];
		elem.fullName = getNonEmpty(actA.fullName);
		elem.createdAt = actA.createdAt;
		elem.id = actA._id;
		elem.active = actA.active;
		elem.light = actA.light;
		elem.moderate = actA.moderate;
		elem.vigorous = actA.vigorous;
		data = data.concat(elem);
	}
	return data;
}

export default function ActivitiesPage() {
	const [data, setData] = useState([]);
	const [selectedActivity, setSelectedActivity] = useState(null);
	const [openConfirmDialog, setOpenConfirmDialog] = useState(null);
	const [refresh, setRefresh] = useState(false);
	const history = useHistory();
	const user = useSelector(
		(store) => store.authentication?.user,
		shallowEqual
	);

	function buttonFormatter(cell) {
		const elem = data.find((item) => item.id === cell);
		return (
			<>
				<Tooltip title="Edit">
					<Button
						style={buttonsStyle}
						size="small"
						onClick={() =>
							history.push("/edit-activity/" + cell)
						}
					>
						<EditIcon />
					</Button>
				</Tooltip>
				{user?.role.includes("admin") && (
					<>
						<Tooltip title={elem?.active ? "Disable" : "Enable"}>
							<Button
								style={buttonsStyle}
								size="small"
								onClick={() => {
									setSelectedActivity(elem);
									setOpenConfirmDialog(1);
								}}
							>
								{elem?.active ? (
									<ToggleOffIcon />
								) : (
									<ToggleOnIcon style={{ color: "#00F" }} />
								)}
							</Button>
						</Tooltip>
						<Tooltip title="Delete">
							<Button
								style={buttonsStyle}
								size="small"
								onClick={() => {
									setSelectedActivity(cell);
									setOpenConfirmDialog(2);
								}}
							>
								<DeleteIcon />
							</Button>
						</Tooltip>
					</>
				)}
			</>
		);
	}

	const numbersHeaderStyle = { width: '150px'};

	const columns = [
		{ dataField: "fullName", text: "Full Name", sort: true },
		{
			dataField: "light",
			text: "light (mets)",
			headerAlign: 'center',
			headerStyle: numbersHeaderStyle,
			align: 'center'
		},
		{
			dataField: "moderate",
			text: "moderate (mets)",
			headerAlign: 'center',
			headerStyle: numbersHeaderStyle,
			align: 'center'
		},
		{
			dataField: "vigorous",
			text: "vigorous (mets)",
			headerAlign: 'center',
			headerStyle: numbersHeaderStyle,
			align: 'center'
		},
		{ 
			dataField: "id",
			text: "", 
			formatter: buttonFormatter,
			headerStyle: { width: '150px' },
			align: 'right',
			headerAlign: 'right' 
		},
	];

	useEffect(() => {
		getActivities()
			.then((res) => {
				if (res.status === 200) {
					setData(getData(res.data));
					setRefresh(false);
				}
			})
			.catch((error) => {
				alertError({
					error: error,
					customMessage: "Could not get activities.",
				});
			});
	}, [refresh]);

	return (
		<>
			<Card>
				<CardHeader title="Activities list">
					<CardHeaderToolbar>
						<button
							type="button"
							className="btn btn-primary"
							onClick={() => history.push("/edit-activity")}
						>
							Add new
						</button>
					</CardHeaderToolbar>
				</CardHeader>
				<CardBody>
					<Table data={data} columns={columns} />
					<ConfirmDialog
						title={`Are you sure you want to ${
							selectedActivity?.active ? "disable" : "enable"
						} this activity?`}
						open={openConfirmDialog === 1}
						setOpen={setOpenConfirmDialog}
						onConfirm={() => {
							changeStatusActivity(
								selectedActivity.id,
								!selectedActivity?.active
							)
								.then((res) => {
									if (res.status === 200) {
										alertSuccess({
											title: `${
												selectedActivity?.active
													? "Disabled!"
													: "Enabled!"
											}`,
											customMessage: `Activity ${
												selectedActivity?.active
													? "disabled"
													: "enabled"
											} successfully`,
										});
										setRefresh(true);
									}
								})
								.catch((error) => {
									alertError({
										error: error,
										customMessage: `Could not ${
											selectedActivity?.active
												? "disable"
												: "enable"
										} activity.`,
									});
								});
						}}
					/>
					<ConfirmDialog
						title={
							"Are you sure you want to remove this activity?"
						}
						open={openConfirmDialog === 2}
						setOpen={setOpenConfirmDialog}
						onConfirm={() => {
							deleteActivity(selectedActivity)
								.then((res) => {
									if (
										res.status === 204 ||
										res.status === 200
									) {
										alertSuccess({
											title: "Deleted!",
											customMessage:
												"Activity removed successfully.",
										});
										setRefresh(true);
									}
								})
								.catch((error) => {
									alertError({
										error: error,
										customMessage:
											"Could not remove activity.",
									});
								});
						}}
					/>
				</CardBody>
			</Card>
		</>
	);
}
